import { Banner, BannersState } from './types'
export const bannersNeedLoading = (state: BannersState): boolean =>
  state.meta.FETCH_BANNERS.loaded
export const allBanners = (state: BannersState): Banner[] =>
  Object.values(state.banners).map((banner, id) => ({
    ...banner,
    id: id + 1,
  }))
